import React, {useMemo, useState} from "react";
import {ReactComponent as PurpleIcon} from '../../assets/call_control_icons/purple.svg';
import {makeStyles} from "@material-ui/styles";
import {Colors} from "../../styles/Colors";
import {useTranslation} from "react-i18next";
import CustomizedTooltip from "../Tooltip/Tooltip";
import {SipCallState} from "../../store/actions/ringgroups/payloads";
import {ManageCallControlProps} from "./callControls.utils";
import classNames from "classnames";
import AddParticipantCallDialog from "./AddParticipantCallDialog";


const useStyles = makeStyles(() => ({
    root: {
        '& path, & rect': {transition: 'fill .4s ease'},
        cursor: 'pointer',
    },
    icon: {
        '& > rect': {
            fill: Colors.White
        },

        '&:hover > rect': {
            fill: Colors.Purple
        },
        '&:hover  path': {
            fill: Colors.White
        },
    },
    disabled: {
        '& > rect': {
            fill: 'transparent'
        },

        '& path': {
            fill: Colors.Gray6
        },
    }
}))


const AddAnotherExtensionToCall: React.VFC<ManageCallControlProps> = (
    {
        activeCallEntity,
        callbackAfterOnClick,
        i_customer,
        isReadOnly,
        accounts,
        sipCalls
    }) => {

    const classes = useStyles();
    const {t} = useTranslation();

    const [isOpen, setIsOpen] = useState(false);

    const enableState = [SipCallState.Connected, SipCallState.Held, SipCallState.Holding];
    const enabledStateCondition = useMemo(()=>{
        return enableState.find((item) => item == activeCallEntity.state) == undefined
    },[activeCallEntity]);
    const disabled = isReadOnly || enabledStateCondition;

    const onSaveClick = () => {
        callbackAfterOnClick?.()
    }
    const toggleVisibility = (value: boolean) => setIsOpen(value);


    const tooltipToShow = useMemo(()=>{
        return disabled
            ? t('common:noPermissionToResource')
            : t('screens:calls.ddParticipant')
    }, [disabled])


    return (
        <>
            <CustomizedTooltip
                title={tooltipToShow}
                copy={false}
                disableHoverListener={!isReadOnly && enabledStateCondition}
            >
                <PurpleIcon
                    className={classNames(classes.root, disabled ? classes.disabled : classes.icon)}
                    onClick={!disabled ? () => toggleVisibility(true) : undefined}
                />
            </CustomizedTooltip>
            <AddParticipantCallDialog
                isOpen={isOpen}
                caller={activeCallEntity.caller}
                callee={activeCallEntity.callee}
                call={activeCallEntity.call}
                toggleVisibility={() => toggleVisibility(false)}
                type={activeCallEntity.type}
                i_customer={i_customer}
                onSaveClick={onSaveClick}
                accounts={accounts}
                sipCalls={sipCalls}
            />
        </>

    )
}

export default AddAnotherExtensionToCall;